import { __exports as PricePresentation } from './_virtual-PricePresentation.js';
import { __require as requireInteropRequireDefault } from './node_modules-@babel-runtime-helpers-interopRequireDefault.js';
import React from 'react';
import { __require as requireLodash_isequal } from './node_modules-lodash.isequal-index.js';
import { __require as requireVpTokenizedFragment } from './vp-tokenized-fragment-build-VpTokenizedFragment.js';
import { __require as requireContainer } from './vp-tokenized-fragment-build-infrastructure-Container.js';

var hasRequiredPricePresentation;

function requirePricePresentation () {
	if (hasRequiredPricePresentation) return PricePresentation;
	hasRequiredPricePresentation = 1;

	var _interopRequireDefault = requireInteropRequireDefault();
	Object.defineProperty(PricePresentation, "__esModule", {
	  value: true
	});
	PricePresentation.default = void 0;
	var React$1 = _interopRequireWildcard(React);
	var _lodash = _interopRequireDefault(requireLodash_isequal());
	var _VpTokenizedFragment = _interopRequireDefault(requireVpTokenizedFragment());
	var _Container = requireContainer();
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	let PricePresentation$1 = class PricePresentation extends React$1.Component {
	  constructor() {
	    super(...arguments);
	    this.state = {
	      token: ''
	    };
	    this._isMounted = false;
	  }
	  async componentDidMount() {
	    this._isMounted = true;
	    await this.refreshToken();
	  }
	  async componentDidUpdate(prevProps) {
	    if (!(0, _lodash.default)(prevProps, this.props)) {
	      await this.refreshToken();
	    }
	  }
	  async componentWillUnmount() {
	    this._isMounted = false;
	  }
	  render() {
	    const elem = /*#__PURE__*/React$1.createElement(_VpTokenizedFragment.default, {
	      culture: this.props.pricingInfo.culture,
	      tenant: this.props.tenant,
	      tokenText: this.state.token,
	      placeHolderText: this.props.placeHolderText,
	      replaceOptions: this.props.replaceOptions,
	      isTile: this.props.isTile
	    });
	    if (this.props.classNameWrapper) {
	      return /*#__PURE__*/React$1.createElement("div", {
	        className: this.props.classNameWrapper
	      }, elem);
	    }
	    return elem;
	  }
	  async refreshToken() {
	    if (!this._isMounted) {
	      return; // if component is unmounted then we will not proceed with the API call or setting state variable
	    }
	    try {
	      const token = await this.getToken();
	      if (this._isMounted) {
	        this.setState({
	          token
	        });
	      }
	    } catch (error) {
	      console.error('ERROR', error.message);
	      if (this._isMounted) {
	        this.setState({
	          token: ''
	        });
	      }
	    }
	  }
	  async getToken() {
	    return await _Container.pricePresentationTokenFactory.generateToken(this.props.pricingInfo, this.props.type);
	  }
	};
	PricePresentation.default = PricePresentation$1;
	
	return PricePresentation;
}

export { requirePricePresentation as __require };
//# sourceMappingURL=vp-tokenized-fragment-build-PricePresentations-PricePresentation.js.map
